import React, { useEffect } from "react";
import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import RequestServiceForm from "../Components/RequestServiceForm";

const GuestRequest = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    if (!state?.serviceId) {
      navigate("/guest", { replace: true });
    }
  }, [state?.serviceId, navigate]);

  if (!state?.serviceId) return null;

  return (
    <Stack gap={3} sx={{ p: 3 }}>
      <Button
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: "14px !important" }} />}
        onClick={() => navigate("/guest")}
        sx={{ alignSelf: "flex-start", textTransform: "none", color: "text.secondary", fontWeight: 600 }}
      >
        العودة
      </Button>

      <Stack direction={isMobile ? "column" : "row"} justifyContent="space-between" gap={2}>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 350,
            border: "2px solid",
            borderColor: "primary.main",
            boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.15)",
          }}
        >
          <Typography variant="h6" color="primary.main">
            {state?.name}
          </Typography>
        </Paper>

        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 300,
            border: "2px solid",
            borderColor: "success.main",
            boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.15)",
          }}
        >
          <AttachMoneyIcon sx={{ mr: 1, color: "success.main" }} />
          <Typography variant="h6" color="success.main">
            {`${state?.applicationFee ?? ""} ${state?.currency?.[0]?.name ?? state?.currency?.[0]?.code ?? ""}`}
          </Typography>
        </Paper>
      </Stack>

      <Box>
        <RequestServiceForm isGuestMode />
      </Box>
    </Stack>
  );
};

export default GuestRequest;
